import axios from 'axios'
import Vue from 'vue'
import qs from "qs";

const state = {
    items: [],
    deleted: [],
    load: false,
    editorOpen: false,
    blockEdit: {
        status: false,
        user: {},
        item: false,
    },
    blockEditTimer: false,
}
let config = function (params) {
    let result = {
        headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
        withCredentials: true,
        paramsSerializer: function(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
        },
    }
    if(params){
        result.params =  params
    }
    return result;
}
const getters = {}
const mutations = {
    setItems(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            Vue.set(state,'items', data.items);
            Vue.set(state,'deleted', data.deleted);
        }
    },
    setEditGroup(state, data){
        state.editGroup = data;
    },
    renameGroup(state, data){
        let index = state.items.findIndex(sect => sect.id === data.id);
        state.items[index].name = data.name;
    },
    addGroup(state, data){
        state.items.push(data);
    },
    setUsersByDepartmentListByIndex(state, data){
        state.items[data.index].contracts = data.items;
    },
    add(state, data){
        for (let i in state.items) {
            if(state.items[i].id == data.id){
                state.items[i].contracts.push(data.contracts[0]);
            }
        }
    },
    refresh(state, data){
        for (let i in state.items) {
            if(state.items[i].id == data.id){
                for (let k in state.items[i].contracts) {
                    if(state.items[i].contracts[k].id == data.contracts[0].id){
                        state.items[i].contracts[k] = data.contracts[0];
                    }
                }
            }
        }
    },
    remove(state, data){
        for (let i in state.items) {
            for (let k in state.items[i].contracts) {
                if(state.items[i].contracts[k].id == data){
                    state.items[i].contracts.splice(k, 1);
                }
            }
        }
    },
    removeGroup(state, data){
        let index = state.items.findIndex(sect => sect.id === data);
        state.items.splice(index, 1);
    },
    setLoad(state, data){
        state.load = data;
    },
    setEditorOpen(state, data){
        state.editorOpen = data;
    },
    setTimerBlockEdit(state, data){
        state.blockEditTimer = data;
    },
    setBlockEdit(state,data){
        state.blockEdit = data;
    },
    clearBlockEdit(state,data){
        if(state.blockEditTimer){
            clearInterval(state.blockEditTimer);
        }
        state.blockEdit = {
            status: false,
            user: {},
            item: false,
        };
    },
}
const actions = {
    getItems(context, data) {
        return new Promise((resolve, reject) => {
            if (!state.isLoad) {
                context.commit('setItems', {});
                axios.get(process.env.VUE_APP_API_PATH + '/rules/contracts/', config({operation: 'list'})).then(response => {
                    context.commit('setLoad', false);
                    if (typeof response.data === 'object' && +response.data.error === 0) {
                        context.commit('setItems', response.data.result);
                    } else {
                        if (+response.data.error === 401) {
                            context.dispatch('auth/logout', {}, {root: true})
                        }
                        if( +response.data.error===401){
                            context.dispatch('auth/logout',{},{root:true})
                        }
                    }
                    resolve();
                }).catch(function (error) {
                    resolve();
                    context.commit('setLoad', false);
                    context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                });
            } else {
                resolve();
            }
        });
    },
    getItem(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/rules/contracts/'+data.id,  config()).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    resolve(response.data.result.item);
                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });
    },
    getItemHistory(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/rules/contracts_archive/'+data.id,  config()).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    resolve(response.data.result.items);
                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });
    },
    save(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contracts/';
            if(data.id){
                url +=  data.id+'/';
            }
            let paramsData = data;

            let formData = new FormData();
            for ( let key in data.form ) {
                formData.append(key, data.form[key]);
            }

            axios.post(url, formData, config()).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(response.data.result.status != 'error'){
                        if(paramsData.id){
                            if(paramsData.group == response.data.result.item.group){
                                context.commit('refresh',  response.data.result.item);
                            }
                            else{
                                context.commit('remove',  paramsData.id);
                                context.commit('add',  response.data.result.item);
                            }

                        }else{
                            context.commit('add',  response.data.result.item);
                        }
                    }

                }
                resolve(response.data.result.item);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    preview(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contracts_pdf/';
            let formData = new FormData();
            for ( let key in data.form ) {
                formData.append(key, data.form[key]);
            }
            let conf = config();
            conf.responseType = 'blob';
            axios.post(url, formData, conf).then(response => {
                resolve(URL.createObjectURL(response.data));
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    uploadImage(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contracts/';
            axios.post(url, data.form_data, config({operation: data.operation})).then(response => {
                resolve(response.data.result.file);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    deleteContract(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/contracts/'+data.id+'/';
            axios.post(url, data.form_data, config({operation: 'delete'})).then(response => {
                resolve(response.data.result.file);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    checkEditItem(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH + '/rules/contracts/'+data.id+'/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: {
                    operation: "checkBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (+response.data.error === 401 && response.data.result.user.login === null) {
                    context.dispatch('auth/logout', {}, {root: true});
                    resolve();
                }
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setBlockEdit', response.data.result);
                    resolve(response.data.result);
                } else {
                    resolve(state.blockEdit);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    setTimerBlockEdit(context, data){
        axios.put(process.env.VUE_APP_API_PATH+'/rules/contracts/' + data.id,{}, {
            withCredentials: true,
            headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
            params: {
                operation: "setBlockEdit"
            },
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            },
        })
        let blockEditTimer = setInterval(()=>{
            axios.put(process.env.VUE_APP_API_PATH+'/rules/contracts/' + data.id,{}, {
                withCredentials: true,
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                params: {
                    operation: "setBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            })
        },60000);
        context.commit('setTimerBlockEdit', blockEditTimer);
    },
    clearBlockEdit(context, data){
        return new Promise((resolve, reject) => {
            context.commit('clearBlockEdit');
            axios.put(process.env.VUE_APP_API_PATH+'/rules/contracts/' + data.id, {},{
                withCredentials: true,
                params: {
                    operation: "clearBlockEdit"
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
            });
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}